const contactPage = (mm, smoother) => {

	const $offices = $('.comp__locations .location');
	
	$offices.each(function(index, el) {
		smoother.effects(el, {lag: 0.3 + index * 0.1});
	});
	
}

export {
	contactPage
};
